export const BASE_PRODUCTS_API = "https://tequipproductsapi.herokuapp.com/products";